<section class="curation-editor-wrapper curation-editor-regimen" *ngIf="isDataLoaded">
  <gen-overlay-loader *ngIf="loading" class="curation-editor-overlay-loader"></gen-overlay-loader>  
  <gen-curation-editor-header
    [curationItem]="curationItem"
    [curationStatus]="curationStatus"
    [revisionsData$]="revisionsData"
    [revisionName]="currentRevisionName"
    [readOnlyUserMode]="readOnlyUserMode"
    (revisionSelected)="revisionHistoryRowClick($event)"
    [revisionLastUpdatedDate]="revisionLastUpdatedDate"
    [lastManualOpinionName]="lastManualOpinionName"
  >
  </gen-curation-editor-header>
  <gen-curation-editor-actions
    [curationStatus]="curationStatus"
    [curationKey]="curationKey"
    [approvalUserMode]="approvalUserMode"
    [publishUserMode]="publishUserMode"
    [curatorUserMode]="curatorUserMode"
    [isAssignee]="isCurationItemAssignedToCurrentUser"
    [buttonsDisabled]="actionsDisabledMode"
    [curationItem]="curationItem"
    [oldRevisionMessage]="oldRevisionMessage"
    [readOnlyUserMode]="readOnlyUserMode"
    [multiStepReview]="multiStepReview"
    [newNotes]="newNotes"
    [reassignButtonDisabled]="isReassignButtonDisabled"
    [historyData]="revisionsData"
    (statusChanged)="changeStatus($event.status)"
    (statusChangedToRejected)="reject()"
    (goBackEvent)="goBack(true)"
    (whiteListFieldChanged)="updateWhiteListFields()"
    (notesPanelToggled)="toggleNotesPanel()"
    (toggleReassignCurationItem)="reassignCurationItem()"
    (toggleSubmitCurationItemForReview)="submitCurationItemForReview()"
    [sameOrganization]= "sameOrganization"
    [showStopWorkflowButton] = "showStopWorkflowButton"
    [showArchiveReason] = "showArchiveReason"
    (toggleShowArchiveReason)="viewArchiveReason()"
  >
  </gen-curation-editor-actions>
  <gen-panel
          name="CURATION-NOTES-PANEL"
          class="{{notesPanelClass}}"
          (toggleDisplayStatusChanged)="toggleDisplayStatusChanged($event)">
  </gen-panel>
  <!-- dynamic forms sections -->
  <section class="scrollable">
    <section class="curation-editor-content" [ngClass]="curationStatus" *ngIf="isDataLoaded && hasForm('details')">
      <span class="titles">Regimen Details</span>
      <gen-dynamic-form
        [listenToDataChange]="true"
        [formData]="formData"
        [formName]="this.editorFormsMap['details'].name"
        [formVertical]="true"
        [updateOnBlur]="false"
        [updatedFieldsContext]="updatedFieldsContext"
        [submitted]="submitted"
        [editMode]="readOnlyMode"
        (formChange)="updateForm($event.form, $event.updated)"
        [disabledFields]="disabledField"
        [disabled]="readOnlyMode"
        (validateChange)="validationEvent($event)"
        (linkClick)="downloadApprovalPDF($event)">
      </gen-dynamic-form>
    </section>
    <section class="item-section" *ngIf="!isRadiationDiscipline && hasForm('summary')">
      <gen-curation-editor-summary
          [readOnly]="readOnlyMode"
          [curationData]="curationItem.curationData"
          [formName]="this.editorFormsMap['summary'].name"
          [title]="''"
          [summarySectionTitle]="''"
          [inlineEdit]="inlineEdit"
          [revisionTag]="revisionTag"
          [submitted]="submitted"
          [approvedMode]="approvedMode"
          [copyAllFields]="false"
          (updateSummaryForm)="updateSummaryForm($event.form, $event.updated)"
        >
      </gen-curation-editor-summary>
    </section>
    <!-- content of below section depends on discipline  -->
    <section class="item-section">
      <gen-curation-editor-table-container
        [title]="getListTitle()"
        [readOnly]="readOnlyMode"
        [tableData]="getListData()"
        [itemTitle]="getItemTitle()"
        [formName]="getFormName()"
        [revisionTag]="revisionTag"
        [approvedMode]="approvedMode"
        [itemOverrides]="getItemOverrides()"
        [userCreatedTag]=undefined
        [submitted] = "submitted"
        [tableUpdatedByCode]="true"
        (itemChanged)="itemUpdate($event)"
        >
      </gen-curation-editor-table-container>
    </section>
  </section>
</section>
